// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"371":"d19fd35a","453":"e76ac4a0"}[chunkId] + ".chunk.js";
};